const booleanStateChangeWrapper = (funct, field, bool) => {
  funct(prevState => ({ ...prevState, [field]: bool }))
}

export default booleanStateChangeWrapper
